// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import moment from 'moment';

const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  // Update the margin value based on the MUI v5 theme structure
  // For example: margin: theme.spacing(1),
  width: 200,
}));

function DatePickers({ label, onChange }) {
  return (
    <StyledForm noValidate>
      <StyledTextField
        id="date"
        label={label}
        type="date"
        defaultValue={moment().format("YYYY-MM-DD")}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={onChange}
      />
    </StyledForm>
  );
}

DatePickers.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func
};

export default DatePickers;
